import React from 'react';
import { v4 as uuid } from 'uuid';

export const RadioButton = React.forwardRef(function RadioButton (props, ref) {
  const {
    checked,
    label,
    name,
    onChange,
    value,
  } = props;

  const _id = `radio_${uuid()}`;

  const handleChange = (/** Event */ event) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <label className="inline-flex items-center mr-4 text-md font-bold" htmlFor={_id}>
      <span className="inline-flex p-2 cursor-pointer">
        <input
          checked={checked}
          className="hidden"
          id={_id}
          name={name}
          onChange={handleChange}
          ref={ref}
          type="radio"
          value={value}
        />
        <span className="flex w-5 h-5 relative border-2 border-solid border-green-light rounded-full align-middle">
          {checked && <span className="block absolute w-3 h-3 inset-0.5 bg-green rounded-full"/>}
        </span>
      </span>
      <span className="cursor-pointer">{label}</span>
    </label>
  );
});
